import { configureStore } from '@reduxjs/toolkit';
// import cycleSliceReducer from './redux/HomePage/cyclesByBuSlice';
const store = configureStore({
  reducer: {
    // cycle: cycleSliceReducer,
   
  }
});

export default store;
